import { useIntl } from 'react-intl';

import styles from './ai-advisor-page.module.css';

const QUICK_QUESTION_IDS = [
	'AIAdvisorIDMessage1',
	'AIAdvisorIDMessage2',
	'AIAdvisorIDMessage3',
	'AIAdvisorIDMessage4',
];

export const QuickQuestions = ({ onSelect, disabled }) => {
	const intl = useIntl();

	return (
		<div className={styles.quickQuestions}>
			<p className={styles.quickQuestionsTitle}>
				{intl.formatMessage({ id: 'AIAdvisorID4' })}
			</p>
			<div className={styles.quickQuestionsGrid}>
				{QUICK_QUESTION_IDS.map(id => {
					const question = intl.formatMessage({ id });
					return (
						<button
							key={id}
							className={styles.quickQuestionButton}
							onClick={() => onSelect(question)}
							disabled={disabled}
						>
							{question}
						</button>
					);
				})}
			</div>
		</div>
	);
};
